import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class AtendimentoAgricolaValidation extends DefaultValidation {

    constructor(msgs) {
        super(msgs);
    }

    validate(model, contatoSelected, refs, checks, validateFinalizar = false, isUpdate) {

        let validated = true;

        if (isUpdate && Util.isNull(model.idAtendimentoErp)) {
            refs.idatendimentoerpInput.focusedOut = true;
            validated = false;
        }

        /* Motivo atendimento */
        if (Util.isNull(model.motivoAtendimento)) {
            refs.motivoAtendimentoSelect.focusedOut = true;
            validated = false;
        }

        /* Empresa não está em motivo de atendimento, mas é obrigatório */
        if (Util.isNull(model.empresa)) {
            refs.empresaSelect.focusedOut = true;
            validated = false;
        }

        /* Cliente não está em motivo de atendimento, mas é obrigatório */
        if (Util.isNull(model.cliente)) {
            refs.clienteSelect.focusedOut = true;
            validated = false;
        }

        /* Funil não está em motivo de atendimento, mas é obrigatório */
        if (Util.isNull(model.funil)) {
            refs.funilSelect.focusedOut = true;
            validated = false;
        }

        /* Etapa não está em motivo de atendimento, mas é obrigatório */
        if (Util.isNull(model.etapa)) {
            refs.etapaSelect.focusedOut = true;
            validated = false;
        }

        if (validated && validateFinalizar) {
            validated = this.validateObriga(model, contatoSelected, refs, checks);
        }

        return validated;
    }

    validateObriga(model, contatoSelected, refs, checks) {

        let validated = true;

        /* Data Atendimento */
        if (checks.dataAtendimento.obriga) {
            if (Util.isNull(model.dataAtendimento)) {
                refs.dataAtendimentoInput.focusedOut = true;
                validated = false;
            } else {
                let rangeDataAtendimento = parseInt(model.dataAtendimento.substr(0, 4) || 0);
                if (rangeDataAtendimento < 1900 || rangeDataAtendimento > 2200) {
                    this.showMessage(new Message('error', 'msg-data-atend-valida-1900-2200', true));
                    refs.dataAtendimentoInput.focusedOut = true;
                    validated = false;
                }
            }
        } else if (model.dataAtendimento) {
            let rangeDataAtendimento = parseInt(model.dataAtendimento.substr(0, 4) || 0);
            if (rangeDataAtendimento < 1900 || rangeDataAtendimento > 2200) {
                this.showMessage(new Message('error', 'msg-data-atend-valida-1900-2200', true));
                refs.dataAtendimentoInput.focusedOut = true;
                validated = false;
            }
        }

        /* Safra */
        if (checks.safra.obriga && Util.isNull(model.safra)) {
            refs.safraSelect.focusedOut = true;
            validated = false;
        }

        /* Propriedade */
        if (checks.propriedade.obriga && Util.isNull(model.propriedade)) {
            refs.propriedadeSelect.focusedOut = true;
            validated = false;
        }

        /* Área */
        if (checks.area.obriga && Util.isNull(model.area)) {
            refs.areaSelect.focusedOut = true;
            validated = false;
        }

        /* Talhão */
        if (checks.talhao.obriga && Util.isNull(model.talhao)) {
            refs.talhaoSelect.focusedOut = true;
            validated = false;
        }

        /* Cultura */
        if (checks.cultura.obriga && Util.isNull(model.cultura)) {
            refs.culturaSelect.focusedOut = true;
            validated = false;
        }

        /* Cultivar */
        if (checks.cultivar.obriga && Util.isNull(model.cultivar)) {
            refs.cultivarSelect.focusedOut = true;
            validated = false;
        }

        /* Fase Fenologica */
        if (checks.faseFenologica.obriga && Util.isNull(model.faseFenologica)) {
            refs.faseFenologicaSelect.focusedOut = true;
            validated = false;
        }

        /* Tipo de Agrovisita */
        if (checks.tipoDeAgroVisita.obriga && Util.isNull(model.tipoAgroVisita)) {
            refs.tipoAgroVisitaSelect.focusedOut = true;
            validated = false;
        }

        /* Assunto da Agrovisita */
        if (checks.assuntoDaAgrovisita.obriga && Util.isNull(model.assuntoAgroVisita)) {
            refs.assuntoAgrovisitaSelect.focusedOut = true;
            validated = false;
        }

        /* Contato Seleção */
        if (checks.contato.obriga && !contatoSelected && contatoSelected.length == 0) {
            refs.contatoSelect.focusedOut = true;
            validated = false;
        }

        /* Contato Texto */
        if (checks.contatoTexto.obriga && Util.isNull(model.contatoTexto)) {
            refs.contatoTexto.focusedOut = true;
            validated = false;
        }

        /* Observacao */
        if (checks.observacao.obriga && Util.isNull(model.observacao)) {
            refs.obsTextArea.focusedOut = true;
            validated = false;
        }

        return validated;
    }

}